// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"38600b0f","453":"03346f77","455":"2bab5da3","977":"240addac"}[chunkId] + ".chunk.js";
};